import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let RTE_imageMap: { [uri: string]: Promise<string> };

const ImageFormatAttributesList = ['alt', 'height', 'width', 'style'];

/**
 * Introduced an alias to Quill.import function as quillImport.
 * WHY?
 * New angular compiler settings prevent the use of reserved keywords like import
 * as function name. The string parameter was misinterpreted as dependency.
 * Can this settings be changed?
 * Maybe. But I bet it is better to leave it as it is. Why use reserved keywords?
 */
const quillImport = Quill.import.bind(Quill);
export const BaseImageFormat = quillImport('formats/image');

/**
 * Extension from 'formats/image' module of quill to allow the image alignment styles and
 * attributes to be included in the output delta and as a result the selected alignment
 * of an image to be saved.
 * Derived from:
 * https://github.com/koan00/quill-image-resize-module/blob/95ba869e4045d267062c3c01091c121141f7004d/src/ImageResize.js
 */
// @dynamic
export default class ImageFormat extends BaseImageFormat {
  public domNode: Element;
  static create(value) {
    const node = super.create(value);
    if (typeof value === 'string') {
      if (typeof RTE_imageMap !== 'undefined' && RTE_imageMap[value]) {
        RTE_imageMap[value].then((url) => {
          node.setAttribute('src', super.sanitize(url));
          node.dataset.imageUri = value;
        });
      } else {
        node.setAttribute('src', super.sanitize(value));
      }
    }
    return node;
  }

  static formats(domNode) {
    return ImageFormatAttributesList.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  static value(domNode) {
    return domNode.dataset.imageUri || domNode.getAttribute('src');
  }

  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}
